import { CheckCircle, XCircle } from '@phosphor-icons/react';
import {
  ButtonSelect,
  CardPlanContainer,
  FunctionalityContent,
  HeaderBlackTip,
  HeaderCard,
  HeaderFlag,
  HeaderPromoImage,
  ListFunctionalitiesContent,
  PriceContent,
  PriceContentFrom,
  PriceContentOrEven,
} from './styles';
import PromotionImage from '../../../../../../../assets/promotion.png';
import { useTitleAndUser } from '../../../../../../../hooks/userTitle';

export function CardPlanPromo() {
  const { user } = useTitleAndUser() as any;
  // 2 anos
  const OFFER = 'c56rnfwi';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '0px',
      }}
    >
      <CardPlanContainer
        className={`${window.screen.width <= 1100 && 'keen-slider__slide '}`}
      >
        <HeaderFlag>melhor oferta</HeaderFlag>
        <HeaderPromoImage>
         {/* <img src={PromotionImage} /> */}
         <span className="percent">20%</span>
         <span className="off">OFF</span>
        </HeaderPromoImage>
        <HeaderCard>
          <h3>iBoxer Premium</h3>
          <HeaderBlackTip>POR 2 ANOS</HeaderBlackTip>

          <PriceContentFrom>
            <span>
              de{' '}
              {/* <span style={{ textDecoration: 'line-through' }}>R$ 398,00</span>{' '} */}
              <span style={{ textDecoration: 'line-through' }}>R$ 299,90</span>{' '}
              por
            </span>
          </PriceContentFrom>
          <PriceContentFrom>
             <strong>R$ 239,90 à vista </strong>
            {/* <strong>R$ 299,90 à vista </strong> */}
          </PriceContentFrom>
          <PriceContentOrEven>
            <span>OU EM ATÉ</span>
          </PriceContentOrEven>
          <PriceContent>
            <div>12X</div>
            <span>R$</span>
            <strong>23,09</strong>
            {/* <strong>28,87</strong> */}
          </PriceContent>
        </HeaderCard>
        <ListFunctionalitiesContent style={{ marginTop: '1rem' }}>
          <li>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Análise detalhada de ativos</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Controle de renda passiva</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso à comunidade</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso aos simuladores de juros</strong>
            </FunctionalityContent>

            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso à carteira inteligente</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso à área educacional</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Funcionalidade de imposto de renda</strong>
            </FunctionalityContent>
            {/* <FunctionalityContent disabled={false}>
              🎁<strong>Presenteie um amigo com 1 ano grátis</strong>
            </FunctionalityContent> */}
          </li>
        </ListFunctionalitiesContent>
        <ButtonSelect
          onClick={() => {
            window.open(
              `https://pay.hotmart.com/R85734558A?checkoutMode=2&email=${user.email}&name=${user.Name}&off=${OFFER}&bid=1774355366782&src=Pagibox6`
            );
          }}
        >
          QUERO SER PREMIUM
        </ButtonSelect>
      </CardPlanContainer>
    </div>
  );
}
